<template>
  <nav :id="`sb-toc-${uid}`" :aria-labelledby="`sb-toc-label-${uid}`" aria-label="Inhaltsverzeichnis">
    <label :id="`sb-toc-label-${uid}`" class="font-bold">Inhaltsverzeichnis</label>
    <ul class="mt-4">
      <atoms-sb-toc-item v-for="heading in orderedHeadings" :key="heading.text" :uid="uid" :heading="heading" />
    </ul>
  </nav>
</template>

<script setup lang="ts">
import type { RichtextStoryblok } from "~/storyblok-component-types"

export type nestedHeading = { level: number; text: string; id: string; children: nestedHeading[]; }

const props = defineProps<{ blok: RichtextStoryblok; uid: string; }>()

const orderedHeadings = computed<nestedHeading[]>(() => {
  const headings: nestedHeading[] = props.blok
    .content!.filter(el => el.type === "heading")
    .filter(el => el.attrs?.level <= 2)
    .map(el => ({
      level: el.attrs.level,
      id: el.marks?.[0].attrs.id ?? "",
      text: el.content?.map(c => c.text).join(", ") ?? "",
      children: [],
    }))

  let headingsNested: nestedHeading[] = []

  while (headings.length > 0) {
    const current = headings.pop()!
    const parent = headings.findLast(heading => heading.level < current.level)
    if (parent) {
      parent.children.unshift(current)
    } else {
      headingsNested.unshift(current)
    }
  }

  if (headingsNested.length === 1 && headingsNested[0].level === 1) {
    headingsNested = headingsNested[0].children
  }

  return headingsNested
})
</script>
